var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col_grow"},[_c('div',{staticClass:"box_spacing box_primary"},[_c('h1',[_vm._v("Dla resellerów")]),_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }